import { getOdebitirBankList } from "@actions/deposit";
import FormItem from "@components/formItem";
import { formatMoney } from "@pages/profile-v2/utils/index.js";
import React from "react";
import { Translate } from "react-localize-redux";
import PaymentSelect from "../../../../../components/paymentSelect/index.jsx";
import { Box, BoxTitle, Content, ContentTitle, Stake } from "../baseItems";
import Base from "./base";

export default class Odebitir extends Base {
	constructor(props) {
		super(props);
		getOdebitirBankList().then((res) => {
			this.setState({ bankList: res.data });
		});
		this.state["selectedCurrency"] = "TRY";
	}

	onSelectBankCode(e) {
		this.setState(
			{
				bank_code: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	getStep1(translate) {
		const { selectedCurrency, bankList, bank_code } = this.state;
		let bankOptions = [{ value: 0, label: translate("PLEASE_SELECT") }];
		bankList &&
			bankList.map((item, index) => {
				let newOpt = { value: index, label: item.name };
				bankOptions.push(newOpt);
			});
		let selectedBank = bank_code ? bankOptions.find((o) => o.value === bank_code).value : 0;
		return (
			<Content>
				<ContentTitle data-testid="step-deposit-amount-title">{translate("Payment_Stake")}</ContentTitle>

				<FormItem onRegister={() => this.registerField({ name: "bank_code" })}>
					<Box>
						<BoxTitle>{translate("BANK_NAME")}</BoxTitle>
						<PaymentSelect
							data-testid="step-deposit-amount-bank-picker"
							options={bankOptions}
							value={selectedBank}
							handleSelect={this.onSelectBankCode.bind(this)}
						/>
					</Box>
				</FormItem>
				{this.getCurrencyField(translate)}
				{bank_code &&
					selectedCurrency &&
					selectedCurrency != translate("PLEASE_SELECT") &&
					this.getStakeField()}
				{this.renderMinMax()}
			</Content>
		);
	}

	renderMinMax() {
		const { selectedCurrency } = this.state;
		const { selectedDeposit } = this.props;

		const currencyToUse = selectedCurrency || selectedDeposit?.currencies?.[0]?.currency;
		const currency = selectedDeposit.currencies.filter(
			(item) => item.currency == currencyToUse
		);
		const min = currency && currency[0] && currency[0].deposit ? currency[0].deposit.min : null;
		const max = currency && currency[0] && currency[0].deposit ? currency[0].deposit.max : null;
		return (
			<Translate>
				{({ translate }) => (
					<div>
						{min && max && (
							<Box>
								<BoxTitle>
									{translate("MIN")} - {translate("MAX")}
								</BoxTitle>
								<Stake>
									{`${formatMoney(min, currencyToUse)} - ${formatMoney(
										max,
										currencyToUse
									)}`}
								</Stake>
							</Box>
						)}
					</div>
				)}
			</Translate>
		);
	}

	makeExternalPayment(newStep) {
		const { stake, bank_code } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				url_redirect: location.href,
				amount: stake.toString(),
				bank_id: bank_code.toString(),
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { iban, stake, bank_code } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				url_redirect: location.href,
				amount: stake.toString(),
				bank_id: bank_code,
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}
}
